import React, { useEffect, useState } from 'react';
import {
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Box
} from '@mui/material';

import './VentasTable.css';

function VentasTable({ id_empleado }) {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tipo, setTipo] = useState('servicios');

  useEffect(() => {
    if (!id_empleado) return;

    setLoading(true);
    const url =
      tipo === 'servicios'
        ?`${process.env.REACT_APP_API_URL}/ventasempleado/${id_empleado}`
        : `${process.env.REACT_APP_API_URL}/ventaproductosempleado/${id_empleado}`;

    fetch(url)
      .then(res => res.json())
      .then(data => {
        setVentas(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error al obtener ventas:', err);
        setVentas([]);
        setLoading(false);
      });
  }, [id_empleado, tipo]);

  const handleChange = (_, newTipo) => {
    if (newTipo !== null) {
      setTipo(newTipo);
    }
  };

  return (
    <Box className="ventas-container">
      <ToggleButtonGroup
        orientation="vertical"
        value={tipo}
        exclusive
        onChange={handleChange}
        aria-label="tipo de ventas"
        className="ventas-toggle-group"
      >
        <ToggleButton value="servicios" className="ventas-toggle-button">Servicios</ToggleButton>
        <ToggleButton value="productos" className="ventas-toggle-button">Productos</ToggleButton>
      </ToggleButtonGroup>

      <Box className="ventas-content">
        {loading ? (
          <CircularProgress />
        ) : ventas.length === 0 ? (
          <Typography variant="body2" className="ventas-empty-message">
            No hay ventas de {tipo} registradas en los últimos 3 meses.
          </Typography>
        ) : (
          <TableContainer className="ventas-table-container">
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Cita</TableCell>
                  <TableCell>Fecha</TableCell>
                  <TableCell>{tipo === 'servicios' ? 'Tratamiento' : 'Producto'}</TableCell>
                  <TableCell>Cliente</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ventas.map((venta) => (
                  <TableRow key={`${venta.id_cita}-${venta.nombre_tratamiento || venta.nombre_producto}`}>
                    <TableCell>{venta.id_cita}</TableCell>
                    <TableCell>{new Date(venta.fecha).toLocaleString()}</TableCell>
                    <TableCell>{venta.nombre_tratamiento || venta.nombre_producto}</TableCell>
                    <TableCell>{venta.nombre_cliente}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  );
}

export default VentasTable;
